(function ($) {

    /*
        Custom scripts for filtering products on category and archive pages.
        Basically: 1. detect a filter being clicked, 2. search all normal listings for matches, 3. if maps are enabled, also remove non-matching "siblings" from the map
        Google Maps makes the logic a bit twisty
        Plus, we write to a custom infoWindow on the fly, instead of using Google's format
    */
    
    $(document).ready(function() 
    {
        var addedMarkers = [];
        var userMarker = null;
        var mc; // clusterer
        var max_results = 100;
        var preferred_zoom = 8;
        var max_zoom = 18;


        var map_on_page = $('.acf-map3').length;

        // NOTE you will need markerclusterer version 2.1.11 to make the maps work
        // NOTE change acf-map class to acf-map3 to make this work
        // NOTE you will need CSS classes for acf-map3 or it won't show

        function new_map3($el) 
        {

            var $markers = $el.find('.marker');
            var args = {
                zoom: preferred_zoom,
                center: new google.maps.LatLng(0, 0),
                fullscreenControl: false,
                mapTypeId: google.maps.MapTypeId.ROADMAP,
                styles: [
                    {
                        "featureType": "water",
                        "elementType": "geometry",
                        "stylers": [
                            {
                                "color": "#e9e9e9"
                            },
                            {
                                "lightness": 17
                            }
                        ]
                    },
                    {
                        "featureType": "landscape",
                        "elementType": "geometry",
                        "stylers": [
                            {
                                "color": "#f5f5f5"
                            },
                            {
                                "lightness": 20
                            }
                        ]
                    },
                    {
                        "featureType": "road.highway",
                        "elementType": "geometry.fill",
                        "stylers": [
                            {
                                "color": "#ffffff"
                            },
                            {
                                "lightness": 17
                            }
                        ]
                    },
                    {
                        "featureType": "road.highway",
                        "elementType": "geometry.stroke",
                        "stylers": [
                            {
                                "color": "#ffffff"
                            },
                            {
                                "lightness": 29
                            },
                            {
                                "weight": 0.2
                            }
                        ]
                    },
                    {
                        "featureType": "road.arterial",
                        "elementType": "geometry",
                        "stylers": [
                            {
                                "color": "#ffffff"
                            },
                            {
                                "lightness": 18
                            }
                        ]
                    },
                    {
                        "featureType": "road.local",
                        "elementType": "geometry",
                        "stylers": [
                            {
                                "color": "#ffffff"
                            },
                            {
                                "lightness": 16
                            }
                        ]
                    },
                    {
                        "featureType": "poi",
                        "elementType": "geometry",
                        "stylers": [
                            {
                                "color": "#f5f5f5"
                            },
                            {
                                "lightness": 21
                            }
                        ]
                    },
                    {
                        "featureType": "poi.park",
                        "elementType": "geometry",
                        "stylers": [
                            {
                                "color": "#dedede"
                            },
                            {
                                "lightness": 21
                            }
                        ]
                    },
                    {
                        "elementType": "labels.text.stroke",
                        "stylers": [
                            {
                                "visibility": "on"
                            },
                            {
                                "color": "#ffffff"
                            },
                            {
                                "lightness": 16
                            }
                        ]
                    },
                    {
                        "elementType": "labels.text.fill",
                        "stylers": [
                            {
                                "saturation": 36
                            },
                            {
                                "color": "#333333"
                            },
                            {
                                "lightness": 40
                            }
                        ]
                    },
                    {
                        "elementType": "labels.icon",
                        "stylers": [
                            {
                                "visibility": "off"
                            }
                        ]
                    },
                    {
                        "featureType": "transit",
                        "elementType": "geometry",
                        "stylers": [
                            {
                                "color": "#f2f2f2"
                            },
                            {
                                "lightness": 19
                            }
                        ]
                    },
                    {
                        "featureType": "administrative",
                        "elementType": "geometry.fill",
                        "stylers": [
                            {
                                "color": "#fefefe"
                            },
                            {
                                "lightness": 20
                            }
                        ]
                    },
                    {
                        "featureType": "administrative",
                        "elementType": "geometry.stroke",
                        "stylers": [
                            {
                                "color": "#fefefe"
                            },
                            {
                                "lightness": 17
                            },
                            {
                                "weight": 1.2
                            }
                        ]
                    }
                ]
            };

            var map = new google.maps.Map($el[0], args);
            
            map.markers = [];
            $markers.each(function () 
            {
                add_marker($(this), map);
            });

            addedMarkers = map.markers;
            

            center_map(map);
            current_window = null;
            add_cluster(map, map.markers);
            //show_user_position(map);

            return map;
        }


        // self explanatory, repositions map according to pins
        // but if we have a user pin, it become the center
        function center_map(map) 
        {

            /*var user_lat = getSimpleValue("user_lat");
            var user_lng = getSimpleValue("user_lng");

            if (user_lng && user_lat)
            {
                var myLatLng = new google.maps.LatLng(user_lat, user_lng);

                map.setCenter(myLatLng);
                map.setZoom(preferred_zoom);
            }
            else
            {*/
                var lng_lats = [];
                var bounds = new google.maps.LatLngBounds();
                $.each(map.markers, function (i, marker) {
                    var latlng = new google.maps.LatLng(marker.position.lat(), marker.position.lng());
                    lng_lats.push( [marker.position.lat(), marker.position.lng()]);
                    bounds.extend(latlng);
                });
                map.setCenter(bounds.getCenter());
                map.setZoom(preferred_zoom);

            //}
        }

        // add clustering
        // note the use of ignoreHidden; essential for hide/show
        function add_cluster(map, markers)
        {
           mc = new MarkerClusterer(map, markers,
            {
                gridSize: 40, 
                maxZoom: 20, 
                zoomOnClick: true, 
                minimumClusterSize: 2,
                imagePath: "/app/themes/hailstone/img/layout/m/m",
                ignoreHidden: true
            });
        }

        // this add_marker requires a custom pin
        function add_marker($marker, map) 
        {
            var latlng = new google.maps.LatLng($marker.attr('data-lat'), $marker.attr('data-lng'));
            var image2 = '/app/themes/hailstone/img/layout/map-icon-purple.png';

    
            var icon = 
            {
                url: image2,
                scaledSize: new google.maps.Size(40,52), // scaled size
            }

            var marker = new google.maps.Marker(
            {
                position: latlng,
                map: map,
                icon: icon,
                id: $marker.attr('id')
            });


            map.markers.push(marker);

            if ($marker.html()) 
            {
                var infowindow = new google.maps.InfoWindow(
                {
                    content: $marker.html(),
                    slug: $marker.attr('id'),
                });

                google.maps.event.addListener(marker, 'click', function () 
                {

                    $('#featuredInfoWindow').slideUp(); // hide the faux infowindow
                    $('#featuredInfoWindow').html(infowindow.content); // replace content with real infowindow's content
                    $('#featuredInfoWindow').slideDown(); // show faux infowindow again

                });
            }
        }


        // show the user's position on the map
        // must be called after clustering, or clustering will kill it.
        function show_user_position(map)  // not in use
        {
            var user_lat = getSimpleValue("user_lat");
            var user_lng = getSimpleValue("user_lng");

            var image2 = '/app/themes/hailstone/img/layout/map-icon-blue.png';

            var icon = 
            {
                url: image2,
                scaledSize: new google.maps.Size(30, 30), // scaled size
            }

            var marker_id = 'map_location_for_user';
            if (user_lng && user_lat)
            {
                if (userMarker)
                {
                    userMarker.setMap(null);
                    userMarker = null;
                }
                var myLatLng = new google.maps.LatLng(user_lat, user_lng);

                userMarker = new google.maps.Marker({
                    position: myLatLng,
                    map: map,
                    icon: icon,
                    id: marker_id,
                });
            }

            return map;
        }



        // helper function to get the value of a node on the page
        function getSimpleValue( el )
        {
            var myInput = document.getElementById(el);
            if (myInput && myInput.innerHTML && myInput.innerHTML.length > 0) 
            {
                return myInput.innerHTML;
            }
            return false;
        }



        if ( $('.acf-map3').length )
        {
            $('.acf-map3').each(function () 
            {
                map = new_map3($(this));
            });

            // this function needs to work on document as the info-panels are dynamically regenereted after initial DOM
            $(document).on("click", ".close-info-panel" , function() 
            {
                $('#featuredInfoWindow').slideUp();
            });

        }


    });


})(jQuery);